import { useSyncExternalStore } from 'react';

/**
 * The first-visit tour ("Como funciona em 3 passos"): shown once per person on this browser, and
 * while it is open no other demonstration runs — the empty order's first-purchase loop reads
 * `useWelcomeTourOpen` and stays quiet, so the screen never plays two lessons at once.
 */
const seenKey = (userId: string) => `instoque.boas-vindas-passos.${userId}`;

export function isWelcomeTourSeen(userId: string | undefined): boolean {
  if (userId === undefined) {
    return true;
  }
  try {
    return localStorage.getItem(seenKey(userId)) === '1';
  } catch {
    return true;
  }
}

export function markWelcomeTourSeen(userId: string): void {
  try {
    localStorage.setItem(seenKey(userId), '1');
  } catch {
    // Blocked storage: the tour may show again on a later sign-in, which is harmless.
  }
}

let open = false;
const listeners = new Set<() => void>();

export function setWelcomeTourOpen(next: boolean): void {
  if (open !== next) {
    open = next;
    listeners.forEach((listener) => {
      listener();
    });
  }
}

export function useWelcomeTourOpen(): boolean {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    () => open,
    () => false,
  );
}
